export default __webpack_public_path__ + "static/media/BlackFrame01.719a1f62.png";